module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-step.js
// module id = 1521
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 17 18 19 20 21